import React, { useState, useEffect } from "react";
import "./rules.css";
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from "sweetalert2"; // Import SweetAlert2 for better UI feedback
// import desktopBg from "../../img/desktop.png";
// import mobBg from "../../img/mob.png";
import logo from "../../img/logo.png";

function Rules({ updateHeader }) {
  const navigate = useNavigate();
  const location = useLocation();
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  // const [riddlerusLogo, SetriddlerusLogo] = useState("../img/logo.png");
  const storedUserData = JSON.parse(sessionStorage.getItem('userData'));
  //const themeData1 = JSON.parse(sessionStorage.getItem('themeData'));
  const [rules, setRules] = useState(["", "", ""]);
  const [textcolor, Setcolorcode] = useState(null);


  useEffect(() => {

    updateHeader({
      backButtonRedirect: "/intro"
    });

  }, [navigate]);

  useEffect(() => {
    setRules([
      "A heist, unprecedented and daring, has shaken the nation. The culprits? In a daring move, amidst the Republic Day fervor, a notorious gang has pulled off an unthinkable heist, stealing the newly designed Indian currency plates.","The theft is not just a blow to the economy, but a challenge to the nation's pride.Your team is the nation's best hope. Can you restore the nation's honor and solve the mystery of the Republic Heist? Trust your instincts, follow the evidence, and remember, in a game of shadows, every detail matters."
      
    ]);
  }, []);

  return (
    <>
      <div className="rules-page-bg-1">

        <div className="rules-main-container-1" style={{ textAlign: "center" }}>
          <div className="rules-main-container1" style={{ textAlign: "center" }}>
            <img src={logo} className="rules-logo-1" />
          </div>

          

          <div>
            <ul className="rules-rules">
              {rules.map((rule, index) => (
                <li key={index}>{rule}</li>
              ))}
            </ul>

          </div>

          <div style={{ textAlign: "center" }}>
            <Link to="/stage1">
              {/* <img src="/img/next-button.png" className="begin-play-img" /> */}
              <button type="button" className="begin-play-btn submit-btn-rules-1">
                Next
              </button>
            </Link>
          </div>
        </div>
      </div>

    </>

  );

}
export default Rules;